import { useAtom } from 'jotai'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { discountAssignInMunicipalityJobIdAtom } from '@/state'
import DiscountAssignInMunicipality from './assign-in-municipality'
import DiscountAssignInMunicipalityStatus from './assign-in-municipality-status'

function YearlyFeeCollectionDiscountsMassActions() {

    const [discountAssignInMunicipalityStatusId, setDiscountAssignInMunicipalityStatusId] = useAtom(discountAssignInMunicipalityJobIdAtom)

    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            pt: 2,
            pb: 3,
        }}>
            <Box sx={(theme) => ({
                border: `1px solid ${theme.palette.customRed.light}`,
                backgroundColor: '#fff8f8',
                p: 2,
                borderRadius: 2.5,
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
            })}>
                <Typography variant="h4" component="h2" textAlign="center">
                    Hromadné operace slev
                </Typography>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                }}>
                    {discountAssignInMunicipalityStatusId &&
                        <DiscountAssignInMunicipalityStatus
                            jobId={discountAssignInMunicipalityStatusId}
                            handleClose={() => setDiscountAssignInMunicipalityStatusId(null)}
                        />
                    }
                </Box>
                <Box sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 1,
                }}>
                    <DiscountAssignInMunicipality />
                </Box>
            </Box>
        </Box>
    )
}

export default YearlyFeeCollectionDiscountsMassActions
